<script setup lang="ts">
import { nextTick, ref, watch } from "vue";
import { floatingTip } from "../composables/tooltip";

/**
 * Draws the tooltip of the `v-tooltip` directive: centred under its element, above it near the
 * bottom of the window, and kept 8 px inside the window's sides.
 */
const el = ref<HTMLElement | null>(null);
const style = ref<Record<string, string>>({});
watch(floatingTip, async (tip) => {
  if (!tip) return;
  // Centred like IconButton's; moved only when it would leave the window.
  style.value = {
    left: `${tip.x}px`,
    top: `${tip.below}px`,
    transform: "translateX(-50%)",
  };
  await nextTick();
  const w = el.value?.offsetWidth ?? 0;
  const h = el.value?.offsetHeight ?? 0;
  const left = Math.min(Math.max(tip.x - w / 2, 8), window.innerWidth - w - 8);
  const top =
    tip.below + h > window.innerHeight - 8 ? tip.above - h : tip.below;
  if (left !== tip.x - w / 2 || top !== tip.below)
    style.value = { left: `${left}px`, top: `${top}px` };
});
</script>
<template>
  <Teleport to="body"
    ><Transition name="fade"
      ><span
        v-if="floatingTip"
        :id="floatingTip.id"
        ref="el"
        role="tooltip"
        class="tooltip tooltip-text"
        :style="style"
        >{{ floatingTip.text }}</span
      ></Transition
    ></Teleport
  >
</template>
